<template>
  <section class="items-panel display-panel">
    <table>
      <colgroup>
        <col class="col-no" />
        <col class="col-type" />
        <col />
        <col class="col-qty" />
        <col class="col-price" />
        <col class="col-total" />
      </colgroup>
      <thead>
        <tr>
          <th>#</th>
          <th>{{ $t('customerDisplay.type') }}</th>
          <th>{{ $t('customerDisplay.description') }}</th>
          <th>{{ $t('customerDisplay.qty') }}</th>
          <th>{{ $t('customerDisplay.unitPrice') }}</th>
          <th>{{ $t('customerDisplay.subTotal') }}</th>
        </tr>
      </thead>
      <tbody v-if="rows.length">
        <tr v-for="(item, index) in rows" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.fee_type || '-' }}</td>
          <td>{{ item.fee_name || '-' }}</td>
          <td>{{ item.qty || 0 }}</td>
          <td>{{ formatAmount(item.unit_price) }}</td>
          <td>{{ formatAmount(item.sub_total) }}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="6" class="empty-row">
            <div class="items-empty">
              <i class="far fa-file-alt"></i>
              <strong>{{ $t('customerDisplay.noItemsTitle') }}</strong>
              <span>{{ $t('customerDisplay.noItemsHint') }}</span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
export default {
  name: 'InvoiceItemsPanel',
  props: {
    rows: { type: Array, default: () => [] }
  },
  methods: {
    formatAmount(value) {
      return `$${Number(value || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    }
  }
}
</script>
